import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConnectApiClientService } from '@aveva/connect-web-core';
import { BannerType } from 'src/app/shared/banner/banner-type';
@Component({
  standalone: false,
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  readonly warningBanner = BannerType.warning;
  okButtonTitle: string;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    public connectApi: ConnectApiClientService,

    @Inject(MAT_DIALOG_DATA) public data: {
      applicationId: string,
      dialogTitle: string,
      description: string;
      cautionaryMessage: string,
      okButtonTitle: string
    }) {
    this.okButtonTitle = data.okButtonTitle;
  }

  async ok(): Promise<void> {
    this.dialogRef.close(true);
  }
}
